export default __webpack_public_path__ + "static/media/Foto-17.bcb72b5f.png";